'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgPartnerEmbed = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M17.47 3H2v2h18v14H4V7H2v14h20V3h-4.53Zm-1.64 12 2.52-3-2.52-3h-2.61l2.52 3-2.52 3h2.61ZM8.17 9l-2.52 3 2.52 3h2.61l-2.52-3 2.52-3H8.17Z" })
);

module.exports = SvgPartnerEmbed;
//# sourceMappingURL=PartnerEmbed.cjs.js.map
